module.exports = __webpack_public_path__ + "img/login_L.2f6c5e94.png";